module.exports = __webpack_public_path__ + "img/3-5.01d0a6f1.svg";